module.exports = __webpack_public_path__ + "img/6b.2a9b9c1d.jpg";